import { useMutation } from '@tanstack/react-query';
import { adminUsersApi } from '../api/admin-users.api';
import { Notification } from '@/shared/components/ahkinia/Notification/notification';

interface ResendInvitationParams {
  adminUserId: string;
  email: string;
}

export const useResendInvitation = () => {
  return useMutation({
    mutationFn: ({ adminUserId, email }: ResendInvitationParams) =>
      adminUsersApi.resendInvitation(adminUserId, { email }),
    onSuccess: () => {
      Notification.success({
        title: 'Invitación reenviada',
        description: 'Se ha enviado un nuevo enlace de configuración al correo indicado.',
      });
    },
  });
};
